// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2DICq","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1m211"};